import NewVersionChecker from './NewVersionChecker';

export default NewVersionChecker;
